var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygonScatterHaikeiFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(680 24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -103.3L98.2 -31.9L60.7 83.6L-60.7 83.6L-98.2 -31.9Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(285 388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -79L75.1 -24.4L46.4 63.9L-46.4 63.9L-75.1 -24.4Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346 108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -99L94.2 -30.6L58.2 80.1L-58.2 80.1L-94.2 -30.6Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528 416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60L57.1 -18.5L35.3 48.5L-35.3 48.5L-57.1 -18.5Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(825 255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60L57.1 -18.5L35.3 48.5L-35.3 48.5L-57.1 -18.5Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83 499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -70L66.6 -21.6L41.1 56.6L-41.1 56.6L-66.6 -21.6Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(817 476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -81L77 -25L47.6 65.5L-47.6 65.5L-77 -25Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157 13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -66L62.8 -20.4L38.8 53.4L-38.8 53.4L-62.8 -20.4Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350 589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -49L46.6 -15.1L28.8 39.6L-28.8 39.6L-46.6 -15.1Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -35L33.3 -10.8L20.6 28.3L-20.6 28.3L-33.3 -10.8Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546 203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -83L78.9 -25.6L48.8 67.1L-48.8 67.1L-78.9 -25.6Z",
    fill: "#009688"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(886 52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -37L35.2 -11.4L21.7 29.9L-21.7 29.9L-35.2 -11.4Z",
    fill: "#009688"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonScatterHaikeiFull);
export default __webpack_public_path__ + "static/media/polygon-scatter-haikei-full.c318266cb5e12f918226b563bbf5bc03.svg";
export { ForwardRef as ReactComponent };